/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { HeroSection, Header, SettingsComp } from '../components';
import { useSMActual } from '../machines/pageContent';
import { useSMRevokeCredential } from '../machines/revokeCredential';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';

import { AMFileDetailService } from '../services';
import { VApplication } from '@/application';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { SearchFilter } from '../../../widgets/filter-widget-react';
import { Modal, Button } from 'react-bootstrap';
import { CheckCircleIcon } from '@heroicons/react/solid';
import { TweetyWidget } from '@vlinder-web/tweety-widget-react';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.AMFileDetailService') as AMFileDetailService;
};

export const ContainerComm = (props: any) => {
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const srv = getSrv();
  const [refreshPagination, setRefreshPagination] = useState(new Date());
  const [show, setShow] = useState({
    open: false,
    key: '',
  });
  const [texts, setTexts] = useState([]);

  useEffect(() => {
    srv?.resetCriteria();
  }, []);

  const { actualPageMachine, actualPageSend, actualPageState } = useSMActual(
    {}
  );
  const {
    revokeCredentialMachine,
    revokeCredentialSend,
    revokeCredentialState,
  } = useSMRevokeCredential({});

  const onRevokeClick = (ids: any) => {
    revokeCredentialSend('START', {
      payload: ids,
    });
  };

  const onRefresh = () => {
    actualPageSend('TRIGGER_REFRESH', {});
    setRefreshPagination(new Date());
  };

  const onClearFilter = () => {
    srv?.resetCriteria();
    actualPageSend('TRIGGER_REFRESH', {});
  };

  const _renderNotification = () => {
    if (revokeCredentialState?.matches('REVOKE_CREDENTIAL_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.revokeCredential || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const onPaginationChange = (event: any) => {
    actualPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    return (
      <Paginate
        {...(actualPageState?.event?.data?.value || {})}
        onPageChange={onPaginationChange}
        key={refreshPagination}
        totalItems={actualPageState?.event?.data?.value?.ultUsers?.length}
      />
    );
  };

  const onApplyFilter = (data: any) => {
    let criteria: any = [];
    criteria =
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        return {
          column: item?.filters?.inputData?.id,
          op: item?.filters?.inputData?.label,
          value: [item?.filters[item?.filters?.inputData?.label]],
        };
      });
    actualPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  const handleClose = () => {
    if (show?.open)
      setShow({
        open: false,
        key: '',
      });
  };

  const _onHeroButtonClick = (key: string) => {
    console.log(`_onHeroButtonClick :`, key);
    if (!show?.open && key === 'print') {
      setTexts([]);
      setShow({
        open: true,
        key,
      });
    } else if (key === 'form') {
      setShow({
        open: true,
        key,
      });
    }
  };

  useEffect(() => {
    const timeoutIds = [];
    const _texts = [
      'Connection request to Secure Storage',
      'Authenticating',
      'Download AM file',
      'Verify AM file integrity Hash in Blockchain',
      'Printer Authorisation verification',
      'Decrypt the AM file',
      'Printing complete',
      'Update the Blockchain smart contract',
      '',
    ];
    if (show?.open && show?.key === 'print') {
      _texts.forEach((text, i) => {
        const timeoutId = setTimeout(() => {
          setTexts((prev) => [...prev, text]);
        }, 2000 * i);

        timeoutIds.push(timeoutId);
      });

      return () => {
        timeoutIds.forEach((id) => clearTimeout(id));
      };
    }
  }, [show]);

  const _renderModalBody = () => {
    let _res: any[] = [];
    texts &&
      Array.isArray(texts) &&
      texts.length > 0 &&
      texts.map((item: any, index: number) => {
        _res.push(
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              minHeight: '5vh',
            }}
          >
            <p style={{ fontSize: '22px', fontWeight: '600' }}>{item}</p>
            {index < texts.length - 1 && (
              <CheckCircleIcon
                className="dropdown-icon text-green-400 me-2"
                width={'22px'}
                color="green"
                style={{
                  paddingLeft: '5px',
                  marginTop: '-15px',
                }}
              />
            )}
          </div>
        );
      });
    return <div style={{ minHeight: '50vh' }}>{_res}</div>;
  };

  const _renderModal = () => {
    console.log(`_renderModal :`, show);
    if (show?.open && show?.key === 'print') {
      return (
        <Modal show={show?.open} size="xl">
          <Modal.Header>
            <Button variant="close" aria-label="Close" onClick={handleClose} />
          </Modal.Header>
          <Modal.Body className="p-0">{_renderModalBody()}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      );
    } else if (show?.open && show?.key === 'form') {
      return (
        <TweetyModal
          show={show?.open}
          size={'xl'}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Submit'}
          //onSubmit={onUpdateProfile}
          onHide={handleClose}
          title={'Authorize to print '}
          tweetyWidgetProps={{
            fields: staticPageContentConfig?.form?.fields,
            layout: staticPageContentConfig?.form?.layout,
          }}
          onSubmit={() => {
            setShow({
              open: false,
              key: '',
            });
          }}
        />
        // <Modal show={show?.open} size="xl">
        //   <Modal.Header>
        //     <Button variant="close" aria-label="Close" onClick={handleClose} />
        //   </Modal.Header>
        //   <Modal.Body className="p-0">
        //     <div>
        //     <TweetyWidget
        //       fields={staticPageContentConfig?.form}
        //       onFormSubmit={() => {
        //         setShow({
        //           open: false,
        //           key: '',
        //         });
        //       }}
        //     />
        //     </div>
        //   </Modal.Body>
        //   <Modal.Footer>
        //     <Button variant="secondary" onClick={handleClose}>
        //       Close
        //     </Button>
        //   </Modal.Footer>
        // </Modal>
      );
    }
  };

  const _renderPage = () => {
    if (actualPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.retrieveCredentials || {})}
        />
      );
    }

    if (revokeCredentialState?.matches('REVOKE_CREDENTIAL')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.revokeCredential || {})}
        />
      );
    }

    if (actualPageState?.matches('RENDER_PAGE')) {
      return (
        <>
          {actualPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(staticPageContentConfig?.loading?.credentialListEmpty || {})}
            />
          ) : (
            <HeroSection
              {...actualPageState?.event?.data?.value}
              onHeroButtonClick={_onHeroButtonClick}
            />
          )}
        </>
      );
    }
    return null;
  };

  const _renderErrorModals = () => {
    if (actualPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.formSubmit || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onRefreshClick={onRefresh}
          />
          {/* <SearchFilter
            {...(staticPageContentConfig?.settings || {})}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          /> */}
          {/* <SettingsComp
            {...(staticPageContentConfig?.settings || {})}
            onApplyFilter={onApplyFilter}
            onClearFilter={onClearFilter}
          /> */}
        </>
      );
    }
    return null;
  };

  return (
    <>
      {_renderHeader()}
      {_renderPage()}
      {/* {_renderPagination()} */}
      {_renderErrorModals()}
      {_renderNotification()}
      {_renderModal()}
    </>
  );
};
